module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cashiermanage"
  }, [_c('div', {
    staticClass: "banner_wrapper"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": ">"
    }
  }, [_c('el-breadcrumb-item', [_vm._v("收银员管理")])], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-wrap"
  }, [_c('div', {
    staticClass: "banner-btn",
    on: {
      "click": _vm.addCashier
    }
  }, [_c('i', {
    staticClass: "icon-create"
  }), _vm._v(" "), _c('span', {
    staticClass: "banner-btn__desc"
  }, [_vm._v("添加收银员")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-header"
  }, [_c('div', {
    staticClass: "panel-select-group"
  }, [_c('div', {
    staticClass: "panel-select__wrapper"
  }, [_c('span', {
    staticClass: "panel-select__desc"
  }, [_vm._v("账户状态")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "全部",
      "size": "small"
    },
    on: {
      "change": _vm.stateChange
    },
    model: {
      value: (_vm.stateValue),
      callback: function($$v) {
        _vm.stateValue = $$v
      },
      expression: "stateValue"
    }
  }, _vm._l((_vm.stateLists), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.name,
        "value": item.value
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "panel-select__wrapper"
  }, [_c('span', {
    staticClass: "panel-select__desc"
  }, [_vm._v("退款权限")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "全部",
      "size": "small"
    },
    on: {
      "change": _vm.rightsChange
    },
    model: {
      value: (_vm.rightsValue),
      callback: function($$v) {
        _vm.rightsValue = $$v
      },
      expression: "rightsValue"
    }
  }, _vm._l((_vm.rightsLists), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.name,
        "value": item.value
      }
    })
  }))], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.cashierData.opusers,
      "row-class-name": "el-table__row_fix",
      "id": "memberredcollect"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "opuid",
      "label": "收银员编号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "opname",
      "label": "姓名"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "mobile",
      "min-width": "80px",
      "label": "电话"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "账户状态",
      "min-width": "80px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-switch', {
          attrs: {
            "on-text": "",
            "off-text": "",
            "on-color": "#FF8100",
            "off-color": "#d8d8d8",
            "on-value": "1",
            "off-value": "0"
          },
          on: {
            "change": function($event) {
              _vm.changeStatus(scope.row.opuid, scope.row.status)
            }
          },
          model: {
            value: (scope.row.status),
            callback: function($$v) {
              _vm.$set(scope.row, "status", $$v)
            },
            expression: "scope.row.status"
          }
        }), _vm._v(" "), _c('span', {
          staticClass: "explain"
        }, [_vm._v(_vm._s(scope.row.status == 1 ? '启用账户' : '禁用账户'))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "refund",
      "label": "退款权限状态",
      "min-width": "80px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-switch', {
          attrs: {
            "on-text": "",
            "off-text": "",
            "on-color": "#7ed321",
            "off-color": "#d8d8d8",
            "on-value": "1",
            "off-value": "0"
          },
          on: {
            "change": function($event) {
              _vm.changeRights(scope.row.opuid, scope.row.refund)
            }
          },
          model: {
            value: (scope.row.refund),
            callback: function($$v) {
              _vm.$set(scope.row, "refund", $$v)
            },
            expression: "scope.row.refund"
          }
        }), _vm._v(" "), _c('span', {
          staticClass: "explain"
        }, [_vm._v(_vm._s(scope.row.refund == 1 ? '开启退款' : '关闭退款'))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "120",
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          staticClass: "el-button__fix",
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.goDetail(scope.row.opuid)
            }
          }
        }, [_vm._v("查看详情")]), _vm._v(" "), _c('a', {
          staticClass: "el-button__fix el-button--text",
          attrs: {
            "href": _vm.downHref + scope.row.opuid,
            "download": ""
          }
        }, [_vm._v("下载收款码")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), (_vm.cashierData.count >= 10) ? _c('div', {
    staticClass: "pagination_wrapper"
  }, [_c('el-pagination', {
    ref: "page",
    attrs: {
      "layout": "total, sizes, prev, pager, next, jumper",
      "page-size": _vm.pageSize,
      "total": _vm.cashierData.count,
      "current-page": _vm.currentPage
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.currentChange
    }
  })], 1) : _c('div', {
    staticClass: "table_placeholder"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f0588486"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cashiermanage/cashiermanage.vue
// module id = 843
// module chunks = 1